import {
  CasualTournamentEntity,
  Game,
} from '@fantaz/shared/data-access/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ADVERTISEMENT_FEATURE_KEY,
  AdvertisementState,
  advertisementAdapter,
} from './advertisement.reducer';

// Lookup the 'CasualTournament' feature state managed by NgRx
const getCasualTournamentState = createFeatureSelector<AdvertisementState>(
  ADVERTISEMENT_FEATURE_KEY,
);

const { selectAll } = advertisementAdapter.getSelectors();

const getAllCasualTournament = createSelector(
  getCasualTournamentState,
  (state: AdvertisementState): CasualTournamentEntity[] => selectAll(state),
);

export const getAllAdvertisement = createSelector(
  getAllCasualTournament,
  (tournaments) => tournaments,
);

export const getRandomAdvertisement = createSelector(
  getAllCasualTournament,
  (tournaments) => {
    const randomIndex = Math.floor(Math.random() * tournaments.length);

    return tournaments[randomIndex];
  },
);
